import {
    SPI,
    ActionType,
    BaseActionWidget,
    ReloadViewActionWidget,
    ViewType,
    Widget
} from '@kunlun/dependencies';
import ProductSeleectUrl from './productSeleectUrl.vue'

@SPI.ClassFactory(
  BaseActionWidget.Token({
    viewType: ViewType.Table,
    actionType: ActionType.Client,
    name: '$$internal_ReloadData',
    model: 'deli.aries.product.selection.Task',
    widget: 'ClientAction'
  })
)
@SPI.ClassFactory(
  BaseActionWidget.Token({
    viewType: ViewType.Table,
    actionType: ActionType.Client,
    name: '$$internal_ReloadData',
    model: 'deli.aries.merchant.DeliAriesMerchantProductSelectionTask',
    widget: 'ClientAction'
  })
)
export class productSeleectUrl extends ReloadViewActionWidget {
  initialize(props: any) {
    super.initialize(props);
    this.setComponent(ProductSeleectUrl);
    return this;
  }
}
